import type { IPublicUser } from '@sravni/types/lib/auth';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type AffiliateSummaryModel from '../../models/AffiliateSummaryModel';
import type AffiliateUserInfoModel from '../../models/AffiliateUserInfoModel';

export type IState = {
  loggedIn: boolean;
  account?: IPublicUser;
  affiliateInfo?: AffiliateSummaryModel;
};

const initialState: IState = {
  loggedIn: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<IPublicUser>) => {
      state.loggedIn = !!payload;
      state.account = payload;
    },
    destroyUser: () => initialState,
    setAffiliateInfo: (state, { payload }: PayloadAction<AffiliateSummaryModel>) => {
      state.affiliateInfo = payload;
    },
    setUserInfo: (state, { payload }: PayloadAction<AffiliateUserInfoModel>) => {
      state.affiliateInfo = { ...state.affiliateInfo, userInfo: payload };
    },
  },
});

const { actions, reducer } = userSlice;

export const { setUser, destroyUser, setAffiliateInfo, setUserInfo } = actions;

export default reducer;
